import { Component, OnInit } from '@angular/core';

@Component({
  selector: "app-stacy",
  templateUrl: "./stacy.component.html",
  styleUrls: ["./stacy.component.css"],
})
export class StacyComponent implements OnInit {
  constructor() {}
  currentYear: number = new Date().getFullYear();

  ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/stacy/stacy.component.ts